<template>
  <h1>{{ $t('VisitorProfiles.headline') }}</h1>

  <AlertBox type="neutral" class="mt-6">
    <template #header>{{ $t('VisitorProfiles.howItWorks.headline') }}</template>
  </AlertBox>
</template>

<script setup lang="ts">
import AlertBox from '@/components/AlertBox.vue'
</script>
